import { render, staticRenderFns } from "./VerticalVariationButtonGroup.vue?vue&type=template&id=7f3df60b"
import script from "./VerticalVariationButtonGroup.vue?vue&type=script&lang=js"
export * from "./VerticalVariationButtonGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports